import { HttpError } from '../../models/http-error';
export const getErrorMessage = (error) => {
    return error instanceof HttpError
        ? error.message
        : typeof error.message === 'object'
            ? JSON.stringify(error.message)
            : error.message || error.toString();
};
export const getErrorName = (error) => error.name;
//# sourceMappingURL=errors.js.map